module.exports = __webpack_public_path__ + "static/img/beianIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beianIcon.png
// module id = zt8A
// module chunks = 1